import {
    CREATE_DYEING_INWARD_MASTER_REQUEST_DK,
    CREATE_DYEING_INWARD_MASTER_SUCCESS_DK,
    CREATE_DYEING_INWARD_MASTER_FAILURE_DK,
    DELETE_DYEING_INWARD_MASTER_REQUEST_DK,
    DELETE_DYEING_INWARD_MASTER_SUCCESS_DK,
    DELETE_DYEING_INWARD_MASTER_FAILURE_DK,
    FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST_DK,
    FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS_DK,
    FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE_DK,
    FETCH_DYEING_INWARD_MASTER_REQUEST_DK,
    FETCH_DYEING_INWARD_MASTER_SUCCESS_DK,
    FETCH_DYEING_INWARD_MASTER_FAILURE_DK,
    UPDATE_DYEING_INWARD_MASTER_REQUEST_DK,
    UPDATE_DYEING_INWARD_MASTER_SUCCESS_DK,
    UPDATE_DYEING_INWARD_MASTER_FAILURE_DK,
    RESET_DYEING_INWARD_MASTER_INFO_DK,
    CREATE_DYEING_INWARD_MASTER_FORM_DK,
    UPDATE_DYEING_INWARD_MASTER_FORM_DK,
    NAVIGATE_DYEING_INWARD_DETAILS_DK,
    NAVIGATE_DYEING_INWARD_MASTER_DK,
    FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_DYEING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID_DK,
    SET_PENDING_GRID_NAME_DYEING_INWARD_DK,
    SET_UNIT_NAME_DYEING_INWARD_DK,
    FETCH_COMPLETE_DYEING_PO_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_DYEING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_DYEING_PO_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK
} from './dyeingInwardHeader.actionsType';

export const DYEING_INWARD_DK_MASTER = 'dyeingInwardDKHeader';

let initialState = {
    loading: false,
    dyeingInwardHeader: [],
    pendingDyeingDc: [],
    completeDyeingDc: [],
    reportSingleDyeProgramInwardList: [],
    activeKey: 1,
    dyeingInwardId: '',
    detailsId: [],
    dyeingInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,

        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedState: {},
    renderGridBtn: 'pendingGrid',
    unitId: '',
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleDyeingInwardData: {},
    isDyeingInwardDetails: false
};

export let dyeingInwardDKHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_DYEING_INWARD_MASTER_REQUEST_DK:
        case FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_DYEING_INWARD_MASTER_REQUEST_DK:
        case UPDATE_DYEING_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST_DK:
        case DELETE_DYEING_INWARD_MASTER_REQUEST_DK:
        case FETCH_COMPLETE_DYEING_PO_IN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardHeader: updatePayload
            };
        case FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingDyeingDc: updatePayload
            };
        case FETCH_COMPLETE_DYEING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                completeDyeingDc: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportSingleDyeProgramInwardList: updatePayload?.Inward
            };
        case CREATE_DYEING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                dyeingInwardId: updatePayload[0]?.fldID,
                detailsId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_DYEING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_DYEING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case RESET_DYEING_INWARD_MASTER_INFO_DK:
            return {
                ...state,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                dyeingInwardId: '',
                detailsId: [],
                activeKey: 1
            };
        case CREATE_DYEING_INWARD_MASTER_FORM_DK:
        case UPDATE_DYEING_INWARD_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    ...state.dyeingInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_DYEING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_DYEING_INWARD_DK:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_DYEING_INWARD_DK:
            return {
                ...state,
                unitId: payload
            };
        case FETCH_DYEING_INWARD_MASTER_FAILURE_DK:
        case FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE_DK:
        case CREATE_DYEING_INWARD_MASTER_FAILURE_DK:
        case UPDATE_DYEING_INWARD_MASTER_FAILURE_DK:
        case FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE_DK:
        case DELETE_DYEING_INWARD_MASTER_FAILURE_DK:
        case FETCH_COMPLETE_DYEING_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID_DK:
            return {
                ...state,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_DYEING_INWARD_DETAILS_DK:
            return {
                ...state,
                isDyeingInwardDetails: true,
                singleDyeingInwardData: updatePayload.singleDyeingInwardData
            };
        case NAVIGATE_DYEING_INWARD_MASTER_DK:
            return {
                ...state,
                isDyeingInwardDetails: false
            };
        default:
            return state;
    }
};
